





















import SegmentationRule from './../targetRules/segmentation.vue';
import { rulesDiscountAndCasbacks } from '@/store/interfaces/discountAndCashbackRules';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'TargetModal',
  components: {
    SegmentationRule,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    updateRule: {
      type: Object as PropType<rulesDiscountAndCasbacks>,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    syncedViewDetails: {
      get(): boolean {
        return this.showModal;
      },
      set(value: boolean): void {
        this.$emit('update:showModal', value);
      },
    },
  },
  methods: {
    restartSegmentationRule(restar: boolean): void {
      this.syncedViewDetails = !restar;
    },
    getSegmentationRule(rule: rulesDiscountAndCasbacks): void {
      this.$emit('rule', rule);
      this.syncedViewDetails = false;
    },
  },
});
